"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _item = _interopRequireDefault(require("./item.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Subset = /*#__PURE__*/function () {
  /**
   * Subset object represents a single partition
   *
   * @constructs Subset
   *
   * @param {Item[]} items
   */
  function Subset() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Subset);

    this.items = items;
    this.sum = this.items.reduce(function (a, c) {
      return a + c.value;
    }, 0);
  }
  /**
   * Returns number of set items
   *
   * @return {number}
   */


  _createClass(Subset, [{
    key: "count",
    value: function count() {
      return this.items.length;
    }
    /**
     * Appends new item
     *
     * @return {this}
     */

  }, {
    key: "append",
    value: function append(item) {
      if (!(item instanceof _item["default"])) {
        throw new Error('Parameter must me of type \'Item\'');
      }

      this.items.push(item);
      this.sum += item.value;
      return this;
    }
    /**
     * Returns lean items array
     *
     * @return {*[]}
     */

  }, {
    key: "lean",
    value: function lean() {
      return this.items.map(function (i) {
        return i.lean();
      });
    }
  }]);

  return Subset;
}();

exports["default"] = Subset;